<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchInspLotForm :propsInspIndexNo="inspIndexNo" :propsAcceptDateFrom="acceptDateFrom" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchInspLotForm from '@/components/organisms/terminal/form/SearchInspLotForm'

export default {
  name: 'SearchInspLotPage',

  components: {
    SearchInspLotForm,
  },

  data() {
    return {
      inspIndexNo: '',
      acceptDateFrom: '',
    }
  },

  created() {
    const query = this.$route.query
    if (query) {
      this.inspIndexNo = query.inspIndexNo
      this.acceptDateFrom = query.acceptDateFrom
    }
  },
}
</script>
